import React, { useEffect, useState } from 'react'
import { Circles } from 'react-loader-spinner'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_ARRAY } from '../../constants/globalConstants'
import { Row } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import { isExtendButton, isSessionNotActive } from '../../utils/helper'
import { useCountDown } from '../../Hooks/countDownHook'

function ExtendEndButton(props) {
  const { isFetching, handleEndParking, handleExtend, isEndParking, isExtendPrimary, screen, isTokenApiStarts, syncWithBtns, wideBtn } = props
  const [isSessionActive, setIsSessionActive] = useState(false)
  let key = 'faclityData'
  if (screen == 'extend') {
    key = 'ExtendData'
  } else {
    key = 'faclityData'
  }
  const [days, hours, minutes, seconds] = useCountDown(screen)
  const facilityData = JSON.parse(localStorage.getItem(key))?.facility
  const { partner } = useParams()

  useEffect(() => {
    const sessionStatus = isSessionNotActive(days, hours, minutes, seconds)
    setIsSessionActive(sessionStatus)
  },[days, hours, minutes, seconds])

  const returnButtons = () => {
    return ( <>
        {(partner && isSessionActive && isExtendButton(facilityData, ['1'])) && <div className={`${syncWithBtns ? 'mb-4 col-sm-12 col-md-4' : wideBtn ? '' : 'col-sm-6 mb-3'}`}>
          <button
            type='button'
            onClick={() => handleExtend()}
            disabled={isTokenApiStarts || isFetching}
            style={{opacity: (isTokenApiStarts || isFetching) ? '0.7' : '1'}}
            className={`${isExtendPrimary ? 'text-decoration-none border-btn border bg-white text-primary border-primary rounded text-center w-100 ps-4 pe-4 pt-2 pb-2 mt-3 mt-sm-0'  : 'text-decoration-none border-btn border bg-white text-primary border-primary rounded text-center w-100 ps-4 pe-4 pt-2 pb-2'}`}>
            {/* <i className='fa fa-plus-circle me-1'></i>Extend */}

            <div className='d-flex justify-content-center align-items-center'>
              <span>{isExtendPrimary ? 'Extend' : 'Extend Duration'}</span>
              <span className='ms-2'>
                {isExtendPrimary && isFetching ? <Circles
                  height="20"
                  width="20"
                  style={{ display: 'inline-block' }}
                  color="var(--bs-primary)"
                  ariaLabel="circles-loading"
                  visible={true}
                /> : null}
              </span>
            </div>
          </button>
        </div>}
        {((facilityData?.is_end_parking != 0 && isEndParking) && isSessionActive) && <div className={`${syncWithBtns ? 'mb-4 col-sm-12 col-md-4' : wideBtn ? '' : 'col-sm-6'}`}>
          <button
            // onClick={() => handleEndParking()}
            
            onClick={handleEndParking}
            type='button'
            className='text-decoration-none border-btn border bg-white text-primary border-primary rounded text-center w-100 ps-4 pe-4 pt-2 pb-2'>
            <div className='d-flex justify-content-center align-items-center'>
              <span>End Current Parking</span>
              <span className='ms-2'>
                {isFetching ? <Circles
                  height="20"
                  width="20"
                  style={{ display: 'inline-block' }}
                  color="#26A8EO"
                  ariaLabel="circles-loading"
                  visible={true}
                /> : null}
              </span>
            </div>
          </button>
        </div>}
      </>
    )
  }

  if(syncWithBtns) {
    return (
      returnButtons()
    )
  } else if(wideBtn) {
    return (
      <div className='mb-4 m-auto justify-content-center'>
        {returnButtons()}
      </div>
    )
  } else {
    return (
      <Row className='mb-4 m-auto justify-content-center'>
        {returnButtons()}
      </Row>
    )
  }
}

ExtendEndButton.propTypes = {
  dispatch: PropTypes.func,
  listData: PropTypes.array,
  isFetching: PropTypes.bool,
  handleEndParking: PropTypes.func,
  handleExtend: PropTypes.func,
  isEndParking: PropTypes.bool.isRequired,
  isExtendPrimary: PropTypes.bool.isRequired,
  screen: PropTypes.string,
  isTokenApiStarts: PropTypes.bool,
  syncWithBtns: PropTypes.bool,
  wideBtn: PropTypes.bool,
}

ExtendEndButton.defaulProps = {
  dispatch: noop,
  listData: EMPTY_ARRAY,
  isFetching: false,
  handleEndParking: noop,
  handleExtend: noop,
  isEndParking: false,
  isExtendPrimary: false,
  screen: undefined,
  isTokenApiStarts: false,
  syncWithBtns: false,
  wideBtn: false,
}

function mapStateToProps() {
  return {}
}

export default connect(mapStateToProps)(ExtendEndButton)